import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/ui/Reveal';
import { allProjects } from '../data/ProjectsData';

const PAGE_SIZE = 12;

export default function Work() {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const projects = useMemo(() => allProjects.slice(0, visible), [visible]);

  useEffect(() => {
    document.title = 'Selected Website Work | Nalexus Technologies';
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage sync-work-page">
      <section className="sync-page-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Selected website work</p>
            <h1>Digital experiences built to be seen and used.</h1>
          </div>
          <div>
            <p className="sync-lead">A restored visual archive of website projects from the previous Nalexus portfolio. We show the work without inventing results, metrics, or client testimonials.</p>
            <Link className="sync-text-link" to="/contact?intent=custom-work">Discuss your website <span aria-hidden="true">→</span></Link>
          </div>
        </div>
      </section>

      <section className="sync-section sync-work-section" aria-labelledby="work-grid-heading">
        <div className="sync-shell">
          <div className="sync-section-heading sync-heading-row">
            <div>
              <p className="sync-kicker">Portfolio archive</p>
              <h2 id="work-grid-heading">Twenty-four verified project covers, restored.</h2>
            </div>
            <p>Each cover and project name comes from the previous Nalexus website source and matching media archive.</p>
          </div>
          <div className="sync-work-grid">
            {projects.map((project, index) => (
              <Reveal key={project.image} className="sync-work-card" delay={Math.min(index % 4, 3) * 0.04}>
                <div className="sync-work-image">
                  <img src={project.image} alt={`${project.title} website project cover`} loading="lazy" />
                </div>
                <div className="sync-work-copy">
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  <div><p>Website delivery</p><h3>{project.title}</h3></div>
                </div>
              </Reveal>
            ))}
          </div>
          {visible < allProjects.length && (
            <div className="sync-work-more">
              <button className="sync-button" type="button" onClick={() => setVisible(allProjects.length)}>Show all website work</button>
            </div>
          )}
        </div>
      </section>

      <section className="sync-section sync-final-cta">
        <div className="sync-shell sync-final-cta-inner">
          <p className="sync-kicker">Your next website should support the operation behind it.</p>
          <h2>Bring the brief, workflow, or idea. We’ll shape the right build.</h2>
          <Link className="sync-button" to="/contact?intent=custom-work">Start a website enquiry</Link>
        </div>
      </section>
    </main>
  );
}
